export const styles = {
  mainContainer: "flex max-h-10 sm:w-fit w-full",
  searchForm:
    "flex justify-between w-full bg-white border border-zinc-400 rounded-full shadow-sm xs:w-fit py-1 focus-within:border-blue-500 focus-within:ring-1",
  searchInput: "border-none rounded-full focus:border-none focus:ring-0",
  clearBtn: "px-4 text-white bg-gray-400 border rounded-full hover:bg-gray-500",
};
